// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"b4-z","displaySixCardTiles":"c4-z"};